import styled from 'styled-components'
import { Container } from 'src/components/common/Container'
import { Noto_body1_b16, Noto_body2_r14 } from 'src/styles/fonts/NotoSansKrFonts'
import { Typography } from 'src/components/common/Typography'
import { Icon } from 'src/assets/svg/Icon'
import { EasyLoginSettingsPageProps } from 'src/pages/EasyLoginSettingPage/index'
import { toggleDataListType } from 'src/pages/NotifySettingPage'
import { Bridge } from 'src/utils/bridge'
import useCustomCookies from 'src/hooks/useCustomCookies.hook'

const EasyLoginSettingsPageView = ({
  toggleDataList,
  onToggleChangeHandler,
}: EasyLoginSettingsPageProps) => {
  const { c_tel } = useCustomCookies()

  return (
    <S.EasyLoginSettingsContainer $option="flex_column">
      <S.SettingItemsWrap
        $option="flex_row_space_between"
        onClick={() => {
          Bridge.handleReqSetEasyLogin(c_tel)
        }}
      >
        <Typography $fontStyle={Noto_body1_b16}>간편 비밀번호 변경</Typography>
        <Icon.Arrow size="16" rotate="right" color="var(--black-30)" />
      </S.SettingItemsWrap>
      {toggleDataList?.map((ele: toggleDataListType, idx) => (
        <S.SettingItemsWrap $option="flex_row_space_between" $column_gap="20px" key={idx}>
          <Container $option="flex_column" $row_gap="6px" $width="fit-content">
            <Typography $fontStyle={Noto_body1_b16}>{ele?.text}</Typography>
            <S.SettingItemsSubtext $fontStyle={Noto_body2_r14} $color="var(--black-50)">
              {ele?.subtext}
            </S.SettingItemsSubtext>
          </Container>
          <S.ToggleWrap $option="flex_row" $column_gap="10px" $width="fit-content">
            <S.ToggleText $fontStyle={Noto_body2_r14} $color="var(--black-70)">
              {ele?.status ? '켜짐' : '꺼짐'}
            </S.ToggleText>
            <S.ToggleSwitch onClick={() => onToggleChangeHandler(ele?.type)} value={ele?.status}>
              <S.ActionCircle value={ele?.status} />
            </S.ToggleSwitch>
          </S.ToggleWrap>
        </S.SettingItemsWrap>
      ))}
    </S.EasyLoginSettingsContainer>
  )
}
export default EasyLoginSettingsPageView

const S = {
  EasyLoginSettingsContainer: styled(Container)`
    flex: 1;
    padding: 30px 20px;
    gap: 10px;
  `,
  SettingItemsWrap: styled(Container)`
    border-radius: 12px;
    background-color: var(--black-4);
    padding: 16px 20px;
    align-items: center;
  `,
  SettingItemsSubtext: styled(Typography)`
    white-space: pre-line;
  `,
  ToggleWrap: styled(Container)`
    align-items: center;
  `,
  ToggleSwitch: styled.section<{ value: boolean }>`
    position: relative;
    width: 40px;
    height: 22px;
    padding: 2px;
    display: flex;
    border-radius: 100px;
    align-items: center;
    background-color: ${({ value }) => (value ? 'var(--brand-50)' : 'var(--black-30)')};
  `,
  ToggleText: styled(Typography)`
    white-space: nowrap;
  `,
  ActionCircle: styled.span<{ value: boolean }>`
    line-height: 20px;
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 100px;
    background-color: var(--white);
    transition: all 0.3s ease-in-out;
    z-index: 1;
    ${({ value }) => (value ? 'transform: translateX(18px)' : 'transform: translateX(0px)')}
  `,
}
